import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M16.736 19.264a.9.9 0 0 1-1.273 1.273l-8-8a.9.9 0 0 1 0-1.274l8-8a.9.9 0 0 1 1.273 1.274L9.373 11.9l7.363 7.364Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "chevron-left-icon"}) } }